import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["loader", "buttons"]

  connect() {
    // Add click listeners to all navigation links
    this.buttonsTargets.forEach(button => {
      if (button.tagName === 'A') {
        button.addEventListener('click', this.handleLinkClick.bind(this))
      }
    })

    // Add click listener to date picker button
    const dateButton = this.element.querySelector('button[onclick*="date-picker-modal"]')
    if (dateButton) {
      dateButton.addEventListener('click', this.handleButtonClick.bind(this))
    }
  }

  handleLinkClick(event) {
    const link = event.currentTarget
    if (link.href && link.href !== window.location.href) {
      this.showLoader()

      // Set a timeout to hide loader in case navigation takes too long
      this.loaderTimeout = setTimeout(() => {
        this.hideLoader()
      }, 3000)
    }
  }

  handleButtonClick(event) {
    // For date picker button, show loader briefly then hide
    this.showLoader()
    setTimeout(() => {
      this.hideLoader()
    }, 500)
  }

  showLoader() {
    this.hideButtons()
    if (this.hasLoaderTarget) {
      this.loaderTarget.classList.remove('hidden')
    }
  }

  hideLoader() {
    this.showButtons()
    if (this.hasLoaderTarget) {
      this.loaderTarget.classList.add('hidden')
    }
    if (this.loaderTimeout) {
      clearTimeout(this.loaderTimeout)
    }
  }

  hideButtons() {
    this.buttonsTargets.forEach(button => {
      button.style.display = 'none'
    })
  }

  showButtons() {
    this.buttonsTargets.forEach(button => {
      button.style.display = 'flex'
    })
  }

  disconnect() {
    this.buttonsTargets.forEach(button => {
      if (button.tagName === 'A') {
        button.removeEventListener('click', this.handleLinkClick.bind(this))
      }
    })

    const dateButton = this.element.querySelector('button[onclick*="date-picker-modal"]')
    if (dateButton) {
      dateButton.removeEventListener('click', this.handleButtonClick.bind(this))
    }

    if (this.loaderTimeout) {
      clearTimeout(this.loaderTimeout)
    }
  }
}